// extracted by mini-css-extract-plugin
export default {"pageContainer":"PedidosProntos_pageContainer__bT0Px","header":"PedidosProntos_header__-uxPx","mainContent":"PedidosProntos_mainContent__1MvnJ"};